import * as React from 'react';
import { compose } from 'recompose';
import { createStyles } from '@material-ui/styles';
import classNames from 'classnames';
import { transition } from '@topconagriculture/theme';
import { withBaseProps } from '../../Utils';
const styles = (theme) => createStyles({
    root: {
        width: '100%',
        display: 'flex',
        position: 'relative',
        height: 30,
        cursor: 'pointer',
        borderRadius: 40,
        backgroundColor: theme.color.grey.lightest,
        boxShadow: theme.common.shadow.default,
        transition: transition(300, 'all', 'ease'),
    },
    rootDisabled: {
        boxShadow: 'none',
        pointerEvents: 'none',
        cursor: 'inherit',
        color: theme.color.grey.default,
        '& $switcher': {
            backgroundColor: theme.color.grey.default,
        },
    },
    switcher: {
        position: 'absolute',
        width: '50%',
        height: '100%',
        borderRadius: '40px',
        backgroundColor: theme.color.primary.main,
        left: 0,
        transition: transition(300, 'all', 'ease'),
    },
    switcherActive: {
        left: '50%',
    },
    textContainer: {
        display: 'flex',
        alignItems: 'center',
        flexBasis: '100%',
        position: 'relative',
        float: 'left',
        textAlign: 'center',
    },
    text: {
        width: '100%',
        fontSize: theme.font.size.mediumSmall,
        transition: transition(400, 'color'),
    },
    textActive: {
        color: theme.color.font.light,
    },
});
const ToggleText = (props) => {
    const { toggleConfig, input, disabled, testId = 'ToggleText', classes } = props;
    if (!input) {
        return null;
    }
    const optionA = toggleConfig[0].key;
    const optionB = toggleConfig[1].key;
    const optionAClass = classNames(classes.text, {
        [classes.textActive]: optionA === input.value,
    });
    const optionBClass = classNames(classes.text, {
        [classes.textActive]: optionB === input.value,
    });
    const newSelectedValue = optionA === input.value ? optionB : optionA;
    const onChange = () => {
        input.onChange(newSelectedValue);
    };
    return (React.createElement("div", { className: classNames(classes.root, { [classes.rootDisabled]: disabled }), onClick: onChange, "data-testid": `${testId}` },
        React.createElement("div", { "data-testid": `${testId}-value`, className: classNames(classes.switcher, { [classes.switcherActive]: optionB === input.value }) }),
        React.createElement("div", { className: classes.textContainer },
            React.createElement("span", { "data-testid": `${testId}-optionA`, className: optionAClass }, toggleConfig[0].label)),
        React.createElement("div", { className: classes.textContainer },
            React.createElement("span", { "data-testid": `${testId}-optionB`, className: optionBClass }, toggleConfig[1].label))));
};
const ComposedToggleText = compose(withBaseProps({ styles }))(ToggleText);
ComposedToggleText.displayName = 'ToggleText';
export default ComposedToggleText;
//# sourceMappingURL=ToggleText.js.map